<script>
  import { slide } from "svelte/transition";

  import Checkbox from "../../Common/Checkbox.svelte";
  import SimpleLinkPicker from "../../Common/SimpleLinkPicker.svelte";
  import {M} from "../../external";

  export let message = {};
</script>

<div class="popup-widget-wrapper">
  <div class="popup-input-wrapper">
    <h5>{M.TITLE}</h5>

    <input type="text" bind:value={message.title} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.MESSAGE}</h5>
    <span class="col20 f-left">{M.MESSAGE_DESC}</span>
    <textarea bind:value={message.description} />
  </div>

  <Checkbox
    clz="f20"
    bind:data={message.withCTA}
    label="{M.ADD_CTA_BUTTON}" />

  {#if message.withCTA}
    <div class="col20 f-left" transition:slide|local={{ duration: 200 }}>
      <div class="popup-input-wrapper">
        <h5>{M.BUTTON_TEXT}</h5>

        <input type="text" bind:value={message.ctaText} />
      </div>

      <div class="popup-input-wrapper">
        <h5>{M.BUTTON_TARGET}</h5>
        <SimpleLinkPicker bind:link={message.ctaTarget} />
      </div>
    </div>
  {/if}
</div>
